import styled from "styled-components";
import { AlertTriangle, Compass, XCircle } from "lucide-react";

export function PainAndReality() {
  return (
    <PainSection>
      <SectionTitle>
        You’re not confused.
        <br />
        You’re just <span style={{ color: "#f59e0b" }}>misdirected.</span>
      </SectionTitle>

      <SectionSub>
        Most developers don’t lack talent. They lack clarity. And without
        clarity, effort gets wasted.
      </SectionSub>

      <Grid>
        <Card>
          <IconWrap>
            <XCircle size={22} />
          </IconWrap>
          <CardTitle>Too many choices</CardTitle>
          <CardText>
            React, React Native, Backend, DevOps… everything looks important,
            nothing feels clear.
          </CardText>
        </Card>

        <Card>
          <IconWrap>
            <AlertTriangle size={22} />
          </IconWrap>
          <CardTitle>Learning without direction</CardTitle>
          <CardText>
            Tutorials completed, confidence missing. You know things, but don’t
            know where you stand.
          </CardText>
        </Card>

        <Card>
          <IconWrap>
            <Compass size={22} />
          </IconWrap>
          <CardTitle>No clear next step</CardTitle>
          <CardText>
            You’re working hard, but unsure if this effort is actually taking
            you closer to a job or growth.
          </CardText>
        </Card>
      </Grid>
    </PainSection>
  );
}

const PainSection = styled.section`
  padding: 120px 24px;
  max-width: 1100px;
  margin: auto;
`;

const SectionTitle = styled.h2`
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 22px;
`;

const SectionSub = styled.p`
  font-size: 17px;
  line-height: 1.7;
  color: #9ca3af;
  max-width: 720px;
  margin-bottom: 60px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 26px;
`;

const Card = styled.div`
  padding: 26px;
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.1);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(56, 189, 248, 0.24);
    box-shadow: 0 20px 60px rgba(56, 189, 248, 0.12);
  }
`;

const IconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f59e0b, #38bdf8);
  margin-bottom: 16px;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const CardText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #9ca3af;
`;
